import app from '@frontend/application-container';
import { img } from '@phi/components';
import { SettingsEntry } from '../settings-entry';
import { ConsistencyChecksIcon } from '..';
import FormToggle from '@frontend/components/FormToggle';
import { h } from 'vue';

export function FindDiscontinuities() {
    return SettingsEntry(
        'Find discontinuities between edges',

        '',

        img(ConsistencyChecksIcon, 'Find discontinuities between edges'),

        h(FormToggle, {
            value: app.state.always_run_consistency_checks_on_vertices,
            'onUpdate:value': x => app.state.always_run_consistency_checks_on_vertices = x,
        }),
    );
}
